export default __webpack_public_path__ + "static/media/close.80b1f8ab.svg";